import type { QueryResult, WatchQueryFetchPolicy } from '@truepill/tpos-react-router'
import { useLazyQuery, useQuery } from '@truepill/tpos-react-router'
import { LIST_FULFILLMENT_ORDERS } from 'gql'
import type { Order, ShippingMethod } from 'types'

export interface GetFulfillmentOrdersParams {
  orderNumber?: number
  customerIds?: string[]
  locationId?: string
  paymentTypes?: string[]
  selectedLocationIds?: string[]
  patientIds?: string[]
  inTriage?: boolean
  triageReasons?: string[]
  fillStages?: string[]
  orderStages?: string[]
  pageNumber?: number
  pageSize?: number
  ndcs?: string[]
  patientName?: string
  patientDob?: string
  drugName?: string
  medicationNames?: string[]
  hasOverdueFills?: boolean
  hasRobotFills?: boolean
  autobotType?: string
  includeTriage?: boolean
  isBatch?: boolean
  isOtcOneItem?: boolean
  isOtcMultiItems?: boolean
  isMultiPet?: boolean
  isReservedForInvestigation?: boolean
  customerRef?: string
  hasNoPrints?: boolean
  hasPickSlipPrints?: boolean
  completeAutomation?: boolean
  rxFillCode?: string
  sortField?: string
  sort?: number
  coreOrderToken?: string
  coreFillRequestToken?: string
  rejectCodes?: string[]
  isOtcOnly?: boolean
  isRxOtcOnly?: boolean
  specialHandlingTags?: string[]
  states?: string[]
  shelfLocations?: string[]
  ignorePodDrugs?: boolean
  selectedPodNames?: string[]
  saturdayDeliveryShippingMethod?: ShippingMethod
  saturdayDeliveryOptIn?: boolean
}

export interface GetFulfillmentOrdersResult {
  getFulfillmentOrders: {
    currentPage: number
    totalRecords: number
    orders: Order[]
  }
}

export const useLazyFulfillmentOrders = (fetchPolicy?: WatchQueryFetchPolicy) => {
  return useLazyQuery<GetFulfillmentOrdersResult, GetFulfillmentOrdersParams>(LIST_FULFILLMENT_ORDERS, {
    fetchPolicy: fetchPolicy ?? 'network-only',
  })
}

const useFulfillmentOrders = (
  orderQueryVariables: GetFulfillmentOrdersParams,
): QueryResult<GetFulfillmentOrdersResult, GetFulfillmentOrdersParams> => {
  return useQuery<GetFulfillmentOrdersResult, GetFulfillmentOrdersParams>(LIST_FULFILLMENT_ORDERS, {
    variables: orderQueryVariables,
    fetchPolicy: 'network-only',
  })
}

export default useFulfillmentOrders
